﻿import common = require("../../common");
import context = require("../context");
import SearchBox = require("../../core/SearchBox");

interface ISettings {
    /** Settings du searchbox (requis si "enableSearchBox" vaut TRUE) */
    searchBoxSettingsLeft?: common.ISearchBoxSettings;
    searchBoxSettingsRight?: common.ISearchBoxSettings;
    /** Valeur de l'attribut HTML "name" du formulaire contenant les champs des filtres du searchbox */
    filtersFormName?: string;
    commonCustomData: common.IPostCustomData;
}

enum SearchBoxSections {
    left = 'left',
    right = 'right'
}

class DefaultTransfertSearchBoxes implements common.IWebComponent {
    private _isInit = false;
    searchBoxLeft: SearchBox;
    searchBoxRight: SearchBox;
    protected readonly _defaultFiltersFormName = 'DefaultSearchBoxFilters';

    init(s: ISettings) {
        if (this._isInit)
            return this;
        this._isInit = true;

        this.setupSearchBoxes(s.searchBoxSettingsLeft, s.searchBoxSettingsRight, s.commonCustomData, s.filtersFormName);

        return context.components.add(this);
    }

    private setupSearchBoxes(searchBoxSettingsLeft: common.ISearchBoxSettings, searchBoxSettingsRight: common.ISearchBoxSettings, commonCustomData?: common.IPostCustomData, filtersFormName?: string) {

        if (!searchBoxSettingsLeft)
            throw "L'argument 'searchBoxSettings' est requis car la propriete 'isEnabledSearchBox' est TRUE.";

        filtersFormName = filtersFormName || filtersFormName === null ? filtersFormName : this._defaultFiltersFormName;

        const pooler = context.components.getPooler();

        if (commonCustomData) {
            SearchBox.ensureCustomDataPropertyIsValid(searchBoxSettingsLeft);
            SearchBox.ensureCustomDataPropertyIsValid(searchBoxSettingsRight);
            SearchBox.transfertCustomData(commonCustomData, searchBoxSettingsLeft.customData);
            SearchBox.transfertCustomData(commonCustomData, searchBoxSettingsRight.customData);
        }

        this.searchBoxLeft = new SearchBox(searchBoxSettingsLeft, filtersFormName, pooler);
        this.searchBoxRight = new SearchBox(searchBoxSettingsRight, filtersFormName, pooler);

        this.searchBoxLeft.setOnPerformActionSuccessCallback(focusedItemId => {
            this.onPerformActionSuccessCallback(SearchBoxSections.left, focusedItemId);
        });
        this.searchBoxRight.setOnPerformActionSuccessCallback(focusedItemId => {
            this.onPerformActionSuccessCallback(SearchBoxSections.right, focusedItemId);
        });
    }

    private onPerformActionSuccessCallback(section: SearchBoxSections, focusedItemId: string) {
        focusedItemId = focusedItemId || null;

        if (section === SearchBoxSections.left)
            this.searchBoxRight.refresh(focusedItemId);
        else
            this.searchBoxLeft.refresh(focusedItemId);
    }
}

export = DefaultTransfertSearchBoxes;
